import {
  CardNumberElement,
  CardNumberElementProps,
} from '@stripe/react-stripe-js';

import useTranslations from 'modules/I18n/hooks/useTranslations';
import styled from 'modules/Theme/styled-components';
import { Box, Text } from 'modules/Ui';
import inputWrapperStyles from 'modules/Ui/Form/Commons/styles/inputWrapperStyles';

import messages from '../messages';
import stripeStyles from './stripeStyles';

interface StripeProps extends CardNumberElementProps {}

const CardStripeStyles = styled(CardNumberElement)`
  ${inputWrapperStyles}
  ${stripeStyles}
`;

const CardNumberStripe = (props: StripeProps) => {
  const { t } = useTranslations();
  return (
    <Box
      gridColumnStart="1"
      gridColumnEnd="3"
      data-testid="cardnumber-iframe-wrap"
    >
      <Text
        color="gray800"
        display="block"
        marginBottom="2px"
        fontSize={14}
        lineHeight={16}
        data-testid="card-number-stripe"
        id="card-number-stripe"
      >
        {t(messages.number)}
        <Text
          color="error"
          fontSize={14}
          fontWeight="500"
          lineHeight="normal"
          marginLeft="4px"
          tag="span"
        >
          *
        </Text>
      </Text>
      <CardStripeStyles {...props} />
    </Box>
  );
};

export default CardNumberStripe;
